import { useLocation } from 'react-router-dom';

export const useIsChatPage = () => {
    const { pathname } = useLocation();
    return (
        pathname === '/' ||
        pathname.startsWith('/thread/') ||
        pathname.startsWith('/thread-shared/')
    );
};
